import { Feature } from '@tencent/workbench';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { IMarkerOptionsFeature, MarkerType, STMarkerStyleDmlC } from '@tencent/chart-drawer-components/lib/interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import i18n from '@i18next/i18n';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import { mappingSymbolToSTMarkerStyleDmlC, markerSymbolMapping } from '../../utils';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { IMarkerProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/geometry/marker/marker.interface';
import { STMarkerStyleDmlC as SlideSTMarkerStyleDmlC } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { IGeometryProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/geometry/geometry.interface';

const MAX_SIZE = 72;
@Feature({
    name: 'MarkerOptionsFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IMarkerOptionsFeature,
})
export class MarkerOptionsFeature extends ChartBaseDrawerFeature implements IMarkerOptionsFeature {
    public getMarkerType(): MarkerType {
        const model = super.getSelectModel();
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return MarkerType.NONE;
        const selectedElement = model.getSelectedElementProperty(true) as unknown as IMarkerProperty;
        if (!selectedElement) return MarkerType.NONE;
        const type = selectedElement.symbol;
        if (!type || type === SlideSTMarkerStyleDmlC.none) return MarkerType.NONE;
        return MarkerType.BUILT_IN;
    }

    public setMarkerType(value: MarkerType) {
        const model = super.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const selectedElement = model.getSelectedElementProperty(true) as unknown as IMarkerProperty;
        if (value === MarkerType.BUILT_IN) {
            if (!selectedElement) {
                // 没有markerProperty, 则通过geometry.parentProperty创建
                const geometry = model.getSelectedElementProperty() as IGeometryProperty;
                geometry.getParentProperty()?.createMarker(SlideSTMarkerStyleDmlC.circle);
            } else {
                const { size } = selectedElement;
                size ? selectedElement.updateProps({ symbol: SlideSTMarkerStyleDmlC.circle })
                    : selectedElement.createMarker(SlideSTMarkerStyleDmlC.circle);
            }
        } else {
            selectedElement.updateProps({ symbol: SlideSTMarkerStyleDmlC.none });
        }
    }

    public getMarkerSymbol(): STMarkerStyleDmlC {
        const model = super.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return STMarkerStyleDmlC.PBDEFAULT;
        const selectedElement = model.getSelectedElementProperty(true) as unknown as IMarkerProperty;
        const type = selectedElement.symbol;
        return mappingSymbolToSTMarkerStyleDmlC(type);
    }

    public setMarkerSymbol(value: STMarkerStyleDmlC) {
        const model = super.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const selectedElement = model.getSelectedElementProperty(true) as unknown as IMarkerProperty;
        selectedElement.updateProps({ symbol: markerSymbolMapping[value] });
    }

    public getMarkerSize() {
        const model = super.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return 0;
        const selectedElement = model.getSelectedElementProperty(true) as unknown as IMarkerProperty;
        if (!selectedElement) return 0;
        const { size } = selectedElement;
        return size || 0;
    }
    public setMarkerSize(value) {
        const model = super.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        if (value > MAX_SIZE) {
            Snackbar.show({
                type: 'info',
                message: i18n.t('标记大小不能超过{0}。', { 0: MAX_SIZE }),
            });
            return;
        }
        const selectedElement = model.getSelectedElementProperty(true) as unknown as IMarkerProperty;
        selectedElement.updateProps({ size: value });
    }
}
